import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'

import ItemDescription from '../../ItemDescription/ItemDescription'

import idnum2itemresnametable from '../../../data/Items/idnum2itemresnametable.json'

function EquipmentModal(props) {
	const currentLocation = props.location
	const itemList = props.itemList

	const [seachText, setSearchText] = useState('')
	const customStyles = {
		overlay: {
			// height: '60%',
		},
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			margin: '20px',
			padding: '0px',
			transform: 'translate(-50%, -50%)',
			height: '60%',
			width: '60%',
			overflow: 'hidden',
			// overflow: 'scroll',
		},
	}

	ReactModal.setAppElement('#root')

	let subtitle

	//reset search when modal is openned
	useEffect(() => {
		if (props.modalIsOpen) setSearchText('')
	}, [props.modalIsOpen])

	function afterOpenModal() {
		// references are now sync'd and can be accessed.
		subtitle.style.color = '#f00'
	}

	const handleTextType = (event) => {
		// console.log(event.target.value)
		setSearchText(event.target.value)
	}
	return (
		<div>
			<ReactModal
				isOpen={props.modalIsOpen}
				onAfterOpen={afterOpenModal}
				onRequestClose={props.closeModal}
				style={customStyles}
				contentLabel='Example Modal'
			>
				<div
					className='modalHeader'
					style={{
						position: 'sticky',
						top: 0,
						backgroundColor: '#FFFFFF',
					}}
				>
					<h2 ref={(_subtitle) => (subtitle = _subtitle)}>
						{currentLocation}
					</h2>
					<input
						type='text'
						placeholder='Search..'
						onChange={handleTextType}
					/>
				</div>
				<div className='modalBody'>
					<div className='selectList'>
						{itemList.map((itm) =>
							itm.Name.toUpperCase().includes(
								seachText.toUpperCase()
							) ? (
								<div
									key={itm.Id}
									className='itemList'
									onClick={
										(e) => props.setLastSelectedItem(itm.Id)
										// 	itm.Id
										// 		? props.setLastSelectedItem(itm.Id)
										// : null
										// (e) => console.log(itm.Id)
									}
								>
									<img
										src={
											'https://images.roprime-simulator.com/item/' +
											//Some items are in idnum2itemresnametable.txt but not all of them
											//if not in idnum2itemresnametable.txt, check iteminfo.lua
											(idnum2itemresnametable[itm.Id] !==
											undefined
												? idnum2itemresnametable[itm.Id]
												: '0') +
											'.bmp'
										}
										alt=''
									/>
									{itm.Slots
										? itm.Name + '[' + itm.Slots + ']'
										: itm.Name}
								</div>
							) : null
						)}
					</div>
					{/* <div className='itemDescModale'> */}
					<ItemDescription
						lastSelectedItem={props.lastSelectedItem}
					/>
					{/* </div> */}
				</div>
			</ReactModal>
		</div>
	)
}

export default EquipmentModal
